import axios from 'axios'

import { cleanBlankValue } from 'utils/helper'

export const getFinanceContacts = (params) => {
  return axios.get('/finance/contacts', { params })
}

export const getFinanceContactDetail = (id, params, config = {}) => {
  return axios.get(`/finance/contacts/${id}`, { params, ...config })
}

export const getFinanceContactDetailStats = (id, params) => {
  return axios.get(`/finance/contacts/${id}/stats`, { params })
}

export const getFinanceContactMoneyInOutStat = (id, params) => {
  return axios.get(`/finance/contacts/${id}/moneyInOutStats`, { params })
}

export const getFinanceContactSalesStats = (id, params) => {
  return axios.get(`/finance/contacts/${id}/salesStats`, { params })
}

export const addFinanceContact = (data) => {
  return axios.post('/finance/contacts', data)
}

export const editFinanceContact = (data) => {
  return axios.put(`/finance/contacts/${data.id}`, data)
}

export const editFinanceContactAsEmployee = (data) => {
  return axios.patch(`/finance/contacts/${data.id}/updateAsEmployee`, data)
}

export const archiveFinanceContact = (id) => {
  return axios.patch(`/finance/contacts/${id}/archive`)
}

export const unarchiveFinanceContact = (id) => {
  return axios.patch(`/finance/contacts/${id}/unarchive`)
}

export const deleteFinanceContact = (id) => {
  return axios.delete(`/finance/contacts/${id}`)
}

export const getSuggestionFinanceContact = (params, options) => {
  return axios.get('/finance/contacts/suggestionPerPage', { ...options, params })
}

export const getFinanceContact = (id) => {
  return axios.get(`/finance/contacts/${id}/name`)
}

export const getFinanceContactLog = ({ id, params } = {}) => {
  return axios.get(`/finance/contacts/${id}/logs`, { params })
}

export const getFinanceContactTransactions = (id, params) => {
  params = cleanBlankValue(params)
  return axios.get(`/finance/contacts/${id}/transactions`, { params })
}

export const uploadImportFinanceContact = (data) => {
  return axios.postForm('/finance/contacts/uploadImport', data)
}

export const uploadImportFinanceContactTransactions = (data) => {
  return axios.postForm('/finance/contacts/transactions/uploadImport', data)
}

export const executeImportFinanceContact = (data) => {
  return axios.post('/finance/contacts/executeImport', data)
}

export const uploadImportFinanceContactPaymentAccountPayable = (data) => {
  return axios.postForm('/finance/contacts/transactions/payments/uploadImport', data)
}

export const executeImportFinanceContactPaymentAccountPayable = (data) => {
  return axios.post('/finance/contacts/transactions/payments/executeImport', data)
}

export const executeImportFinanceContactTransactions = (data) => {
  return axios.post('/finance/contacts/transactions/executeImport', data)
}

export const exportFinanceContact = (params) => {
  params = cleanBlankValue(params)
  return axios.get('/finance/contacts/export', { responseType: 'arraybuffer', params })
}

export const inputMassDeleteFinanceContact = (data) => {
  return axios.post('/finance/contacts/inputMassDelete', data)
}

export const executeMassDeleteFinanceContact = (data) => {
  return axios.delete('/finance/contacts/executeMassDelete', { data })
}

export const deleteOnAddFinanceContactPhoto = (url) => {
  return axios.delete('/finance/contacts/photo', { data: { url } })
}

export const deleteOnEditFinanceContactPhoto = ({ id, url }) => {
  return axios.delete(`/finance/contacts/${id}/photo`, { data: { url } })
}

export const getInvoiceStatusByContact = ({ id, params }) => {
  return axios.get(`/finance/contacts/${id}/invoiceStatus`, { params })
}

export const getPurchaseInvoiceStatusByContact = ({ id, params }) => {
  return axios.get(`/finance/contacts/${id}/purchaseStatus`, { params })
}

export const getContactSummmary = (params) => {
  return axios.get('/finance/contacts/summary', { params })
}

export const getContactSummaryById = (id, params) => {
  return axios.get(`/finance/contacts/${id}/summary`, { params })
}

export const inputMassDeletePayableFinanceContactDetail = (data) => {
  const { contactId, ...rest } = data
  return axios.post(`/finance/contacts/${contactId}/payable/inputMassDelete`, rest)
}

export const executeMassDeletePayableFinanceContactDetail = (data) => {
  const { contactId, ...rest } = data
  return axios.delete(`/finance/contacts/${contactId}/payable/executeMassDelete`, { data: rest })
}

export const inputMassDeleteReceivableFinanceContactDetail = (data) => {
  const { contactId, ...rest } = data
  return axios.post(`/finance/contacts/${contactId}/receivable/inputMassDelete`, rest)
}

export const executeMassDeleteReceivableFinanceContactDetail = (data) => {
  const { contactId, ...rest } = data
  return axios.delete(`/finance/contacts/${contactId}/receivable/executeMassDelete`, { data: rest })
}

export const createShippingAddress = ({ id, ...data }) => {
  return axios.post(`/finance/contacts/${id}/shippingAddress`, data)
}

export const editBillingAddress = ({ id, ...data }) => {
  return axios.patch(`/finance/contacts/${id}/billingAddress`, data)
}

export const editContactDescription = ({ id, data }) => {
  return axios.patch(`/finance/contacts/${id}/description`, data)
}

export const getFinanceContactCompanies = (params) => {
  return axios.get('/finance/contactCompanies', { params })
}
